import { render, staticRenderFns } from "./ChipsFilterGroup.vue?vue&type=template&id=0f230978&scoped=true"
import script from "./ChipsFilterGroup.vue?vue&type=script&lang=js"
export * from "./ChipsFilterGroup.vue?vue&type=script&lang=js"
import style0 from "./ChipsFilterGroup.vue?vue&type=style&index=0&id=0f230978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f230978",
  null
  
)

export default component.exports